import { EbayPresenter } from 'components/domain/ebay/EbayPresenter'
import { AppLayout } from 'components/facets'
import { useUser } from 'components/providers/UserProvider'
import { Redirect } from 'react-router-dom'

export const Ebay = (): JSX.Element => {
  const { user, hasPermission } = useUser()

  if (!user || user?.subscription.allFeaturesDisabled || !hasPermission('use_internal_tools')) {
    return <Redirect to="/" />
  }

  return (
    <AppLayout noDOMLayout>
      <EbayPresenter />
    </AppLayout>
  )
}
